import {
  IS_UXBEAUTY,
  UserStateContextType
} from 'components/constants/Constants';
import { useUserState } from 'context/User';
import { isSupport } from 'helpers/Roles';

export const useIsBrandPortalRoute = () => {
  const userState = useUserState();
  if (
    userState.type === UserStateContextType.AUTHENTICATED &&
    !isSupport(userState.user) &&
    !IS_UXBEAUTY &&
    userState.user?.brandPortalEvent
  ) {
    const { brandPortalEvent } = userState.user;
    if (!brandPortalEvent.length) return '';
    //assuming a user has just one brand portal event, we need to rethink this in the future
    //once we support multiple brand portal, but i think there wont be a way to make it possible without the dropdown again
    return brandPortalEvent[0].key;
  }
  return '';
};
